import { useCallback, useState } from "react";
import securityDashboardService from "../services/securityDashboardService";

export default function useSecurityDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await securityDashboardService.fetch();
      setData(payload);
    } catch (err) {
      console.error("Error cargando dashboard seguridad", err);
      setError(err?.message || "No se pudo cargar el dashboard");
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    loading,
    error,
    fetchDashboard,
  };
}
